<template>
<div class="instrument-CU">
    <v-icon class="close-btn" @click="$emit('closeDialog')">close</v-icon>
    <v-container>
      <h1 class="header-text">
          <span>
            <span v-if="isUpdate">Uređivanje instrumenta</span>
            <span v-else>Dodavanje instrumenta</span>
            <div class="header-text-line"></div>
          </span>
        </h1>
        <v-form class="form">
            <v-flex xs12>
                <v-text-field 
                v-model="instrument.Name" 
                label="Naziv"></v-text-field>
            </v-flex>
            <v-flex xs12>
                <span>Boja</span>
                <div class="color" :style="{backgroundColor:instrument.Color.hex}">
                </div>
            </v-flex>
            <v-flex xs12>
                <photoshop-picker 
                label="Prezime"
                v-model="instrument.Color" 
                ></photoshop-picker>
            </v-flex>
            <v-flex xs12 class="text-right">
                <v-btn class="main-btn" v-if="isUpdate" @click="updateInstrument">Sačuvaj</v-btn>
                <v-btn class="main-btn" v-else @click="postInstrument">Kreiraj</v-btn>
            </v-flex>

        </v-form>
    </v-container>
</div>
</template>

<script>
import { Chrome } from "vue-color";
export default {
  props: ["instrumentId", "isUpdate", "dialog"],
  components: {
    "photoshop-picker": Chrome
  },
  data() {
    return {
      instrument: {
        Color: {
          hex: "#FF0000"
        }
      }
    };
  },
  methods: {
    getInstrument() {
      this.$store.state.services.instrumentService
        .get(this.instrumentId)
        .then(response => {
          this.instrument = response.data;
          var color = this.instrument.Color;
          this.instrument.Color = { hex: color };
        });
    },
    postInstrument() {
      this.instrument.Color = this.instrument.Color.hex;
      this.$store.state.services.instrumentService
        .add(this.instrument)
        .then(response => {
          this.$emit("addedOrChanged",response.data);
          this.resetInstrument();
        });
    },
    updateInstrument() {
      this.instrument.Color = this.instrument.Color.hex;
      this.$store.state.services.instrumentService
        .update(this.instrument)
        .then(response => {
          this.$emit("addedOrChanged",response.data);
          this.resetInstrument();
        });
    },
    resetInstrument() {
      this.instrument = {
        Color: {
          hex: "#FF0000"
        }
      };
    }
  },
  watch: {
    dialog() {
      if (this.dialog == false) {
        this.resetInstrument();
      }else if(this.isUpdate){
        this.getInstrument();
      }
    }
  }
};
</script>

<style scoped>
.form{
  margin-top: 20px;
}
.close-btn {
    float: right;

}
h2 {
  text-align: center;
}
.instrument-CU {
  padding: 10px 15px;
}
.color {
  height: 20px;
  margin-bottom: 15px;
  margin-top: 5px;
}
</style>
